import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const processed = useRef(false);
  const navigate = useNavigate();
  const { refresh } = useAuth();
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        if (sid) await api.post("/auth/session", { session_id: sid });
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        navigate("/", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);
  return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Memverifikasi sesi...</div>;
}
